import type { TextField } from '@payloadcms/plugin-form-builder/types'
import type { Control, FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import React from 'react'

import { Address } from '../Address'
import { Error } from '../Error'
import { Width } from '../Width'

export const Text: React.FC<
  TextField & {
    control: Control
    errors: Partial<FieldErrorsImpl>
    register: UseFormRegister<FieldValues>
    usePlaceholders?: boolean
    /** CMS "Placeholder / hint text" — example text shown inside the empty field */
    placeholder?: string
  }
> = ({
  name,
  defaultValue,
  errors,
  label,
  register,
  required,
  width,
  control,
  usePlaceholders,
  placeholder,
}) => {
  if (/address/i.test(name)) {
    return (
      <Address
        name={name}
        control={control}
        errors={errors}
        label={label}
        required={required}
        width={width}
        usePlaceholders={usePlaceholders}
      />
    )
  }

  const placeholderText = usePlaceholders ? `${label}${required ? '*' : ''}` : placeholder

  return (
    <Width width={width}>
      <Label htmlFor={name} className={usePlaceholders ? 'sr-only' : undefined}>
        {label}

        {required && (
          <span className="required">
            * <span className="sr-only">(required)</span>
          </span>
        )}
      </Label>
      <Input
        defaultValue={defaultValue}
        id={name}
        type="text"
        placeholder={placeholderText}
        {...register(name, { required })}
      />
      {errors[name] && <Error name={name} />}
    </Width>
  )
}
